<template>
  <div>
    <v-sheet
      v-if="listLoading"
      class="d-flex flex-column justify-center"
      min-height="200px"
    >
      <div
        class="mx-auto"
      >
        <v-progress-circular
          :size="40"
          color="primary"
          indeterminate
        />
      </div>
    </v-sheet>

    <RevisionList
      v-else
      :revisions="revisions"
      @revision-click="onRevisionClick"
    />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useModals } from '@/stores/modals/modals';
import RevisionList from '@ui/components/editor/RevisionList/RevisionList.vue';

const {
  revisions, isHrisProfile, jobProfile, readOnly,
} = storeToRefs(useCurrentJobProfile());
const { listLoading } = storeToRefs(useAppLoading());
const { setModal } = useModals();

const load = () => {
  if (isHrisProfile.value || jobProfile.value?.last_revision_ulid) {
    useCurrentJobProfile().loadRevisions();
  }
};

onMounted(() => load());

watch([
  () => jobProfile.value?.last_revision_ulid,
  () => jobProfile.value?.finalized_revision_ulid,
  isHrisProfile,
], () => {
  load();
});

const onRevisionClick = ({ revision }) => {
  const profileUlid = jobProfile.value?.ulid;
  const latestRevisionUlid = revisions.value[0]?.ulid;

  if (!latestRevisionUlid || !revision?.ulid) return;

  setModal({
    field: 'jobProfileCompare',
    value: true,
    params: {
      revisions: revisions.value,
      oldSide: {
        isHrisProfile: isHrisProfile.value,
        profileUlid,
        revisionUlid: revision.ulid,
      },
      newSide: {
        isHrisProfile: isHrisProfile.value,
        profileUlid,
        revisionUlid: latestRevisionUlid,
      },
      readOnly: readOnly.value,
    },
  });
};
</script>

<style lang="less" scoped>
.revision-list :deep(.revision-item) {
  .timeline-line {
    height: 100px;
  }
  &:first-child .timeline-line {
    height: 75px;
  }
  &:last-child .timeline-line {
    height: 75px;
  }
}
</style>
